import { HomePage } from "./../home/home";
import { PlazaStatSubPage } from "./../plaza-stat-sub/plaza-stat-sub";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";
import { GoogleChartInterface } from "ng2-google-charts/google-charts-interfaces";

@IonicPage()
@Component({
  selector: "page-plaza-stat",
  templateUrl: "plaza-stat.html",
})
export class PlazaStatPage {
  round = 0;
  theme = 1;

  constructor(public navCtrl: NavController, private storage: Storage) {}

  public pieChart: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: [
      ["Merchant 1", 5],
      ["Merchant 2", 3],
      ["Merchant 3", 4],
    ],
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237'},
        // alignment: 'center',
        // maxLines: 2
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 5,
        bottom: 5,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: ["#eb7838", "#418bca", "#5c297f"],
      animation: {
        duration: 1000,
      },
    },
  };

  public barChart: GoogleChartInterface = {
    chartType: "ColumnChart",
    dataTable: [
      [
        "MERCHANT",
        "ROUND 1",
        { role: "annotation" },
        "ROUND 2",
        { role: "annotation" },
        "MERCHANT 3",
        { role: "annotation" },
      ],
      ["MERCHANT 1", 5, 5, 7, 7, 17, 28],
      ["MERCHANT 2", 8, 7, 10, 10, 23, 25],
      ["MERCHANT 3", 6, 4, 10, 15, 18, 29],
    ],
    options: {
      title: "",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237'},
        // alignment: 'center',
        // maxLines: 1
      },
      bar: { groupWidth: "95%" },
      backgroundColor: { fill: "transparent" },
      isStacked: true,
      colors: ["#eb3732", "#814098", "#f3953e"],
      chartArea: {
        left: 20,
        top: 5,
        width: "100%",
        height: "90%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      height: 360,
      hAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        viewWindow: { min: 0 },
      },
      vAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        ticks: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
      },
    },
  };

  public pieChart2: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: [
      ["Merchant 1", 7],
      ["Merchant 2", 3],
      ["Merchant 3", 4],
    ],
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237'},
        // alignment: 'center',
        // maxLines: 2
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 30,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: ["#99211d", "#5c297f", "#eb7838"],
      animation: {
        duration: 1000,
      },
    },
  };

  public barChart2: GoogleChartInterface = {
    chartType: "ColumnChart",
    dataTable: [
      [
        "MERCHANT",
        "ROUND 1",
        { role: "annotation" },
        "ROUND 2",
        { role: "annotation" },
        "MERCHANT 3",
        { role: "annotation" },
      ],
      ["MERCHANT 1", 15000, 15000, 13000, 13000, 125000, 125000],
      ["MERCHANT 2", 11700, 11700, 125000, 125000, 103000, 103000],
      ["MERCHANT 3", 12300, 123000, 25000, 25000, 129000, 129000],
    ],
    options: {
      title: "",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237'},
        // alignment: 'center',
        // maxLines: 3
      },
      bar: { groupWidth: "95%" },
      backgroundColor: { fill: "transparent" },
      isStacked: true,
      colors: ["#eb3732", "#814098", "#f3953e"],
      chartArea: {
        left: 40,
        top: 5,
        width: "100%",
        height: "90%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      height: 360,
      hAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        viewWindow: { min: 0 },
      },
      vAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        // ticks: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50]
      },
    },
  };

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  subPage() {
    this.navCtrl.push(PlazaStatSubPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-stat/plaza-stat.ts